module.exports = __webpack_public_path__ + "img/artboard8.93d8c7fa.png";